import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import AdminLayout from 'screens/admin/AdminLayout'
import { Navigate } from 'react-router-dom'

const LocationNotFound = ComponentLoader(
  lazy(() => import('screens/unauthorize/location-not-found'))
)

const NoLocationRoutes = [
  {
    path: '',
    element: <AdminLayout />,
    children: [
      {
        path: '',
        index: true,
        element: <LocationNotFound />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate replace to={'/'} />,
  },
]

export default NoLocationRoutes
